
export const LoginSpoof = (function() {

    var defaults = {
        loginSelector: '.js-login-btn',
        logoutSelector: '.js-logout-btn',
        backToAccountSelector: '.js-back-to-account-btn'
    };

    var redirectUserLogin = function(event, url) {
        clearStorage(event);

        $.ajax({
            url: url,
            type: 'GET',
        })
        .done((data) => {
            if (data.permissions && data.permissions.length) {
                window.location.href = data.redirect;
            } else {
                console.log('No permissions returned in response');
            }
        })
        .error((xhr) => {
            FlashMessage.message({
                message: 'Invalid Login Attempt',
                type: 'error',
                showClose: true
            });
        });
    };

    var logout = function(event) {
        clearStorageRedirect(event, '/logout');
    };

    var clearStorageRedirect = function(event, href) {
        clearStorage(event);
        window.location.href = href;
    };

    var clearStorage = function(event) {
        sessionStorage.clear();
    };

    return {
        redirectUserLogin: redirectUserLogin,

        initLogin: function(btnSelector) {
            var selector = btnSelector || defaults.loginSelector;
            $(document).on('click', selector, function(e){
                redirectUserLogin(e, $(this).data("redirect"));
            });
        },

        initBackToAccount: function(btnSelector) {
            var selector = btnSelector || defaults.backToAccountSelector;
            $(document).on('click', selector, function(e){
                redirectUserLogin(e,  '/login/back');
            });
        },

        initLogout: function(btnSelector) {
            var selector = btnSelector || defaults.logoutSelector;
            $(document).on('click', selector, function(e){
                logout(e);
            });
        }
    }
})();
